import { render, staticRenderFns } from "./orders-distribute.vue?vue&type=template&id=739e0117&scoped=true"
import script from "./orders-distribute.vue?vue&type=script&lang=js"
export * from "./orders-distribute.vue?vue&type=script&lang=js"
import style0 from "./orders-distribute.vue?vue&type=style&index=0&id=739e0117&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739e0117",
  null
  
)

export default component.exports